module.exports = __webpack_public_path__ + "img/facebook.3f911ac0.svg";